import { useState } from "react";
import toast from "react-hot-toast";
import { TagSelector } from "./TagSelector";

type FileUploaderProps = {
  onUpload: (
    file: File,
    category: string,
    title: string,
    tagIds: number[]
  ) => Promise<void>;
  isUploading: boolean;
};

export const FileUploader = ({ onUpload, isUploading }: FileUploaderProps) => {
  const [file, setFile] = useState<File | null>(null);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("works");
  const [selectedTags, setSelectedTags] = useState<number[]>([]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file || !title) return;

    try {
      await onUpload(file, category, title, selectedTags);
      toast.success("ファイルのアップロードが完了しました！");
      setFile(null);
      setTitle("");
      setSelectedTags([]);
    } catch (error) {
      toast.error("アップロードに失敗しました。もう一度お試しください。");
      console.error("Upload error:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block mb-2">
          タイトル
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-1 p-2 block w-96 rounded-md border-gray-300 shadow-sm"
            required
          />
        </label>
      </div>

      <div>
        <label className="block mb-2">
          カテゴリー
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="mt-1 block p-2 w-96 rounded-md border-gray-300 shadow-sm"
          >
            <option value="works">作品</option>
            <option value="misc">題材</option>
            <option value="other">その他</option>
            <option value="icon">アイコン</option>
          </select>
        </label>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">
          ファイル
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="mt-1 block w-full"
            required
          />
        </label>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">
          タグ
          <TagSelector
            selectedTags={selectedTags}
            onTagsChange={setSelectedTags}
          />
        </label>
      </div>

      <button
        type="submit"
        disabled={isUploading || !file || !title}
        className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
      >
        {isUploading ? "アップロード中..." : "アップロード"}
      </button>
    </form>
  );
};
